module.exports = __webpack_public_path__ + "img/logo.42cf8de8.png";